import { render, staticRenderFns } from "./TaskPage.vue?vue&type=template&id=020d2744&"
import script from "./TaskPage.vue?vue&type=script&lang=ts&"
export * from "./TaskPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports